
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/value-bracket",
      function () {
        return require("private-next-pages/value-bracket/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/value-bracket"])
      });
    }
  